<template>
  <oie-my-pages-template
    v-element-loader="{endpoint: 'downloads'}"
    :title="t('myDownloadsTitle')"
    :inert="inertAttribute">
    <div v-if="downloads && downloads.isPriceListConsentGiven">
      <p>{{ t('myDownloadsSubTitle') }}</p>
      <oie-action-wrapper class="my-downloads__actions">
        <oie-new-pricelist-download-slide-in
          ref="addOptionSlideIn"
          :label-text="t('priceListName')"
          :title="t('requestPriceListFormHeader')"
          :text="t('requestPriceListFormText')"
          @add-option="requestNewDownload">
          <template #activator="{open}">
            <oie-base-action
              v-tooltip.top="t('requestPriceListLinkTooltip')"
              theme="flat"
              @click="open">
              <template #iconPrepend>
                <oie-base-icon icon="documentExport" size="s"></oie-base-icon>
              </template>
              {{ t('requestPriceListLinkText') }}
            </oie-base-action>
          </template>
        </oie-new-pricelist-download-slide-in>
      </oie-action-wrapper>

      <div class="my-downloads__content">
        <oie-downloads-table :downloads="filteredDownloads"></oie-downloads-table>
      </div>
    </div>
  </oie-my-pages-template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myPages from '@/mixins/my-pages'
import OieDownloadsTable from './downloads-table.vue'
import { showDownloadsPriceListConsentModal } from '@/core/modal-service'

export default {
  components: {
    OieDownloadsTable
  },
  mixins: [myPages],
  data() {
    return {
      formatOptions: [
        { value: 'xlsx', text: 'Excel' },
        { value: 'csv', text: 'CSV' }
      ]
    }
  },
  computed: {
    ...mapGetters('myDownloads', ['downloads', 'filter', 'filteredDownloads', 'downloadsIsLocked']),
    inertAttribute() {
      return this.downloadsIsLocked ? { inert: true } : undefined
    }
  },
  async mounted() {
    await this.getDownloads()
    if (this.downloadsIsLocked) {
      showDownloadsPriceListConsentModal()
    }
  },
  methods: {
    ...mapActions('myDownloads', ['getDownloads', 'setFilter', 'addNewDownload']),
    ...mapActions('ui', ['setActiveSlideIn']),
    async requestNewDownload(format) {
      await this.addNewDownload({ format })
      this.$refs.addOptionSlideIn.newOption = ''
      this.setActiveSlideIn(null)
    }
  }
}
</script>

<style lang="scss">
.my-downloads__actions,
.my-downloads__content {
  margin-top: 10px;
}

.oie-my-pages-template[inert] {
  filter: blur(5px);
}
</style>
